import { Link } from 'react-router-dom';
import { BrandMark } from './icons';

export default function BrandLogo() {
  return (
    <Link to="/" aria-label="Color Match home" className="inline-flex shrink-0 items-center gap-2.5 rounded-lg text-lg font-bold tracking-tight text-ink">
      <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-neutral-800 text-white"><BrandMark size={25} aria-hidden="true" /></span>
      <span className="text-neutral-900">Color<span className="text-neutral-600">Match</span></span>
    </Link>
  );
}
